import React, { useState, useEffect, useMemo } from "react";
import Breadcrumbs from "./Breadcrumbs.js";
import AvailableFolders from "./AvailableFolders.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";

import "./FoldersContainer.scss";

const FoldersContainer = ({ children }) => {
  const {
    getMailId,
    fetchFoldersData,
    getFoldersList,
    getIsCollection,
    getCurrentCollection,
    getCurrentFolder,
  } = useMail();
  const [loading, setLoading] = useState(true);

  //component did mount and ready to get data from API
  useEffect(() => {
    getMailId() && !getIsCollection() && fetchFoldersData();
  }, [getMailId(), getIsCollection(), getCurrentFolder()]);

  useMemo(() => {
    getFoldersList().length > 1 && setLoading(false);
  }, [getFoldersList()]);

  return !getCurrentCollection() &&
    !getIsCollection() &&
    getFoldersList().length > 1 &&
    !loading ? (
    <>
      <Breadcrumbs />
      <AvailableFolders />
    </>
  ) : null;
};

export default FoldersContainer;
